import React from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Stack,
  Avatar,
} from "@mui/material";
import Hero from "../components/Hero/Hero";
import Projects from "../components/Projects/Projects";
import Experience from "../components/Experience/Experience";
import Contact from "../components/Contact/Contact";
import { PROFILE, SKILLS, CONTACT as CONTACT_INFO } from "../utils/constants";

const Home = () => {
  return (
    <Box>
      <Hero />

      <Container maxWidth="lg">
        <Box id="about" sx={{ py: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={7}>
              <Card sx={{ borderRadius: 4, height: "100%" }}>
                <CardContent sx={{ p: 3.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: { xs: "flex-start", sm: "center" },
                      gap: 2,
                      flexDirection: { xs: "column", sm: "row" },
                      mb: 3,
                    }}
                  >
                    <Avatar
                      src={CONTACT_INFO.profileImage}
                      alt={CONTACT_INFO.fullName}
                      imgProps={{
                        loading: "lazy",
                        referrerPolicy: "no-referrer",
                      }}
                      sx={{
                        width: 95,
                        height: 95,
                        border: "3px solid",
                        borderColor: "primary.main",
                      }}
                    />
                    <Box>
                      <Typography
                        variant="h2"
                        sx={{
                          mb: 0.5,
                          fontSize: { xs: "2rem", md: "2.75rem" },
                          background:
                            "linear-gradient(135deg, #2563eb, #7c3aed)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        About Me
                      </Typography>
                      <Typography color="text.secondary">
                        Software Engineer · Frontend Developer · Product Builder
                      </Typography>
                    </Box>
                  </Box>

                  <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
                    {PROFILE.about}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={5}>
              <Card sx={{ borderRadius: 4, height: "100%" }}>
                <CardContent sx={{ p: 3.5 }}>
                  <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                    Core Skill Areas
                  </Typography>

                  <Typography sx={{ fontWeight: 700, mb: 1 }}>
                    Frontend / Backend
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={1}
                    flexWrap="wrap"
                    useFlexGap
                    sx={{ mb: 2.5 }}
                  >
                    {SKILLS.proficient.slice(0, 8).map((item) => (
                      <Chip key={item} label={item} size="small" />
                    ))}
                  </Stack>

                  <Typography sx={{ fontWeight: 700, mb: 1 }}>
                    Tools & Concepts
                  </Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    {SKILLS.tools.map((item) => (
                      <Chip
                        key={item}
                        label={item}
                        size="small"
                        variant="outlined"
                      />
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Projects limit={6} showHeader />
        <Experience />
        <Contact />
      </Container>
    </Box>
  );
};

export default Home;
